import { getAuth } from 'firebase/auth';

const API_BASE = process.env.REACT_APP_API_URL;

async function getAuthToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Usuario no autenticado');
  return await user.getIdToken();
}

/**
 * Fetch the current user's email preferences and the canonical list
 * registry shape needed to render the UI.
 *
 * Backend merges stored prefs with defaults so unknown keys come back
 * as opted-in; the frontend just renders whatever it gets.
 */
export async function getMyEmailPreferences() {
  const token = await getAuthToken();
  const response = await fetch(`${API_BASE}/api/me/email-preferences`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Error ${response.status}`);
  }
  return await response.json();
}

/**
 * Patch the current user's email preferences. Partial body: either
 * `preferences` (per-list bool map), `unsubscribedAll` (master switch),
 * or both. Transactional lists are 400 from the backend.
 */
export async function patchMyEmailPreferences(body) {
  const token = await getAuthToken();
  const response = await fetch(`${API_BASE}/api/me/email-preferences`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Error ${response.status}`);
  }
  return await response.json();
}
